import { registerBlockType } from "@wordpress/blocks";
import Edit from "./edit";
import save from "./save";
import metadata from "./block.json";

// Use the name from block.json to ensure consistency
registerBlockType(metadata.name, {
	edit: Edit,
	save,
});
